import { mdiMonitorDashboard } from '@mdi/js'

export default [
  {
    title: 'Monitoring',
    icon: mdiMonitorDashboard,
    children: [
      {
        title: 'IntegrationExchanges',
        to: 'integration-exchange-list',
        permission: 'Permissions.IntegrationLogRead',
      },
      {
        title: 'PaymentCallbacks',
        to: 'payment-callback-list',
        permission: 'Permissions.OrderRead',
      },
      {
        title: 'WebHooks',
        to: 'webhook-list',
        permission: 'Permissions.IntegrationLogRead',
      },
      {
        title: 'SmsJournal',
        to: 'sms-journal',
        permission: 'Permissions.SmsJournalRead',
      },
      {
        title: 'WorkFlows',
        to: 'workflow-list',
        permission: 'Permissions.WorkflowRead',
      },
      {
        title: 'ExchangeStorage',
        to: 'exchange-storage',
        permission: 'Permissions.ExchangeStorageRead',
      },
    ],
  },
]
